module.exports = __webpack_public_path__ + "static/img/logo.260566b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tlsp/logo.png
// module id = QAsm
// module chunks = 23